import React from 'react';
import { motion } from 'framer-motion';
import { QuoteIcon } from 'lucide-react';
import { moreResults } from '../data/testimonials';
export function MoreResults() {
  return <section className="bg-white py-16 sm:py-20" aria-labelledby="results-title" data-id="element-173" data-mp="28f82wp6nw5vc">
      <div className="mx-auto max-w-5xl px-4" data-id="element-174" data-mp="28d54bgrg14f0">
        <p className="text-center text-xs font-extrabold uppercase tracking-[.18em] text-earth" data-id="element-175" data-mp="2d66krt7atc0p">Más resultados reales</p>
        <h2 id="results-title" className="mt-3 text-center text-3xl font-extrabold text-field sm:text-4xl" data-id="element-176" data-mp="2h6qioyzp4jnw">
          Docentes de Yacimientos de Hidrocarburos que ya cambiaron su forma de enseñar
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-177" data-mp="2r68zx7o81rc9">
          {moreResults.map(([initials, name, place, quote], index) => <motion.article key={name} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex flex-col rounded-xl border border-line bg-cream p-6" data-id="element-178" data-mp="2w2pxeshb9i20" data-mpi={index}>
              <QuoteIcon className="h-6 w-6 text-gold-dark" aria-hidden="true" data-id="element-179" data-mp="3ikmq8izdhxq1" />
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-muted" data-id="element-180" data-mp="3do61bmkcnfbw">“{quote}”</blockquote>
              <div className="mt-auto flex items-center gap-3 border-t border-line pt-4" data-id="element-181" data-mp="38qcxh06iqxes">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-field text-sm font-extrabold text-cream" data-id="element-182" data-mp="a6e49trcw56u">
                  {initials}
                </span>
                <span data-id="element-183" data-mp="7f30w8x7btv">
                  <b className="block text-sm text-ink" data-id="element-184" data-mp="at9afkpg56l">{name}</b>
                  <small className="text-xs text-muted" data-id="element-185" data-mp="3sbhgdyfqphgr">{place}</small>
                </span>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}